import React from "react";
import "./EmcureModalShell.css";

/**
 * Shared full-screen modal frame (chart/table full-view) used by Chat and Admin.
 * Renders overlay, panel, title row, optional header controls, close, and body.
 */
export default function EmcureModalShell({
  onClose,
  title,
  headerExtra = null,
  bodyClassName = "chart-modal-body",
  children,
}) {
  return (
    <div className="chart-modal-overlay" onClick={onClose} role="presentation">
      <div className="chart-modal chart-modal-sizing" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="chart-modal-header">
          <h3>{title}</h3>
          <div className="emcure-modal-header-actions">
            {headerExtra}
            <button type="button" className="chart-modal-close" onClick={onClose} aria-label="Close">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 4L4 14M4 4L14 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div className={bodyClassName}>{children}</div>
      </div>
    </div>
  );
}
